// extracted by mini-css-extract-plugin
export default {"container":"LotteryResult_container__vB1wy","progressContainer":"LotteryResult_progressContainer__IrWts"};